export const iconFontAwesomeAlertCircleRadiation = (
	<i className="fa-solid fa-circle-radiation"></i>
);
